import type { ReactNode } from "react";
import { Check, Loader2, AlertTriangle } from "lucide-react";
import { cn } from "@/utils/ui";

type Tone = "done" | "working" | "attention" | "neutral";

const TONES: Record<Tone, string> = {
	done: "bg-constructive/15 text-constructive",
	working: "bg-secondary text-secondary-foreground",
	attention: "bg-caution/15 text-caution",
	neutral: "bg-muted text-muted-foreground",
};

/** Status is always colour + icon + word, never colour alone. */
export function StatusPill({ tone = "neutral", children, className }: { tone?: Tone; children: ReactNode; className?: string }) {
	const Icon = tone === "done" ? Check : tone === "working" ? Loader2 : tone === "attention" ? AlertTriangle : null;
	return (
		<span className={cn("inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium", TONES[tone], className)}>
			{Icon && <Icon className={cn("size-3", tone === "working" && "animate-spin")} aria-hidden />}
			{children}
		</span>
	);
}
